import { css as o } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as l, PropertyStyleSheetBehavior as m } from "@matrix42/fast-foundation";
import { designTokens as s } from "../design-tokens.js";
function e(t, a) {
  return new m("position", t, a);
}
const i = (t) => o`
  ::slotted(${t.prefix}-toast) {
    /* Base */
    height: 0;
    opacity: 0;
    transform: translateY(100%);
    /* Transitions */
    transition: transform ${s.transition.fast},
      opacity ${s.transition.fast};
  }

  ::slotted(${t.prefix}-toast[show]) {
    /* Base */
    height: auto;
    opacity: 1;
    transform: translateY(0);
  }
`, n = (t) => o`
  ::slotted(${t.prefix}-toast) {
    /* Base */
    height: 0;
    opacity: 0;
    transform: translateY(-100%);
    /* Transitions */
    transition: transform ${s.transition.fast},
      opacity ${s.transition.fast};
  }

  ::slotted(${t.prefix}-toast[show]) {
    /* Base */
    height: auto;
    opacity: 1;
    transform: translateY(0);
  }
`, p = (t) => o`
  ${n(t)}
  :host {
    /* Layout */
    top: 0;
    left: 0;
    right: 0;
    justify-content: center;
  }

  .control {
    /* Layout */
    flex-direction: column-reverse;
  }
`, f = (t) => o`
  ${n(t)}
  :host {
    /* Layout */
    top: 0;
    left: 0;
  }

  .control {
    /* Layout */
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`, y = (t) => o`
  ${n(t)}
  :host {
    /* Layout */
    top: 0;
    right: 0;
  }

  .control {
    /* Layout */
    flex-direction: column-reverse;
    align-items: flex-end;
  }
`, c = (t) => o`
  ${i(t)}
  :host {
    /* Layout */
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
  }
`, h = (t) => o`
  ${i(t)}
  :host {
    /* Layout */
    bottom: 0;
    left: 0;
  }

  .control {
    /* Layout */
    align-items: flex-start;
  }
`, u = (t) => o`
  ${i(t)}
  :host {
    /* Layout */
    bottom: 0;
    right: 0;
  }

  .control {
    /* Layout */
    align-items: flex-end;
  }
`, L = (t) => o`
    ${r}
    ${l("flex")}
    :host {
      /* Base */
      pointer-events: none;
      position: fixed;
      overflow: hidden;
      /* Layout */
      padding: ${s.spacing[5]};
    }

    .control {
      /* Layout */
      display: flex;
      flex-direction: column;
      gap: ${s.spacing[5]};
      align-items: center;
    }
  `.withBehaviors(
  e("top", p(t)),
  e("top-left", f(t)),
  e("top-right", y(t)),
  e("bottom", c(t)),
  e("bottom-left", h(t)),
  e("bottom-right", u(t))
);
export {
  L as toasterStyles
};
